import { UserForm } from '@/components/auth/forms/user.form';
import { PhotoForm } from '@/components/auth/forms/photo.form';
import { CollegeCountryForm } from '../forms/college-country.form';
import { NhssaaView } from './nhssaa.view';
import { Slide } from './signup.types';
import { AccountStatus } from '@sportspredict/shared';

export const slides: Slide[] = [
	{
		id: 'user',
		title: 'Before we begin',
		description: "Let's get you set up!",
		Component: UserForm,
	},
	{
		id: 'photo',
		title: 'Add Your Personal Touch',
		description: 'Upload a photo to make your profile feel more you.',
		Component: PhotoForm,
	},
];

export const probability_user_slide: Slide = {
	id: 'user',
	title: 'Before we begin',
	description: "Let's get you set up!",
	Component: UserForm,
};

export const probability_slides: Slide[] = [
	{
		id: 'college_country',
		title: 'Complete your profile',
		description: '',
		Component: CollegeCountryForm,
	},
];

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface GetActiveSignupSlidesParams {
	isProbabilityFlow: boolean;
	needsProbabilityUsername: boolean;
	isNhssaaFlow: boolean;
	isChangingParentEmail: boolean;
	accountStatus?: AccountStatus;
}

export function getActiveSignupSlides({
	isProbabilityFlow,
	needsProbabilityUsername,
	isNhssaaFlow,
	isChangingParentEmail,
	accountStatus,
}: GetActiveSignupSlidesParams): Slide[] {
	const baseSlides = isProbabilityFlow
		? needsProbabilityUsername
			? [probability_user_slide, ...probability_slides]
			: probability_slides
		: slides;

	// Approval activates the account. Profile completion must not restart consent.
	if (!isNhssaaFlow || accountStatus === AccountStatus.Active) return baseSlides;

	return [
		baseSlides[0],
		{
			id: 'nhssaa',
			title: isChangingParentEmail
				? 'Change parent email'
				: 'One more step,\na parent needs to say yes',
			description: isChangingParentEmail
				? 'Enter a new parent or guardian email address.'
				: 'Because you are or under 16 years of age,\na parent or guardian needs to approve your\naccount before you can participate.',
			Component: NhssaaView,
			buttonText: isChangingParentEmail ? 'Update email' : 'Send request',
		},
	];
}
